var _desc, _defs, _rect, _text, _text2, _path, _path2, _path3, _g, _g2, _g3, _g4, _rect2, _text3, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntegratedSearchArchitectureMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 1160",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "\uD1B5\uD569 \uC81C\uD734\uB9C1\uD06C \uAC80\uC0C9 \uD750\uB984") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "36\uB9CC \uAC1C \uC774\uC0C1\uC758 \uC81C\uD734\uB9C1\uD06C\uB97C \uC815\uC81C\uD574 \uD1B5\uD569 \uAC80\uC0C9\uACFC \uD53C\uB4DC\uBC31\uC744 \uAC70\uCCD0 \uB9C1\uD06C \uC0DD\uC131\uC73C\uB85C \uC5F0\uACB0\uD558\uB294 \uC138\uB85C\uD615 \uB124 \uB2E8\uACC4 \uD750\uB984")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "arrow",
    viewBox: "0 0 10 10",
    refX: 9,
    refY: 5,
    markerWidth: 8,
    markerHeight: 8,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 L10 5 L0 10Z",
    fill: "#43a9df"
  })), /*#__PURE__*/React.createElement("style", null, "\n      text { font-family: Pretendard, \"Apple SD Gothic Neo\", \"Noto Sans KR\", sans-serif; }\n      .title { fill: #26384b; font-size: 42px; font-weight: 800; letter-spacing: -0.5px; }\n      .subtitle { fill: #748396; font-size: 24px; font-weight: 650; }\n      .label { fill: #26384b; font-size: 34px; font-weight: 800; }\n      .label-accent { fill: #1377ad; font-size: 34px; font-weight: 800; }\n      .caption { fill: #748396; font-size: 24px; font-weight: 650; }\n      .metric { fill: #1377ad; font-size: 24px; font-weight: 800; }\n      .metric-label { fill: #748396; font-size: 17px; font-weight: 650; }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 1160,
    rx: 38,
    fill: "#fbfcfd"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 52,
    y: 70,
    className: "title"
  }, "\uAC80\uC0C9\uD574\uC11C \uB9C1\uD06C \uB9CC\uB4E4\uAE30")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 52,
    y: 108,
    className: "subtitle"
  }, "\uAE30\uC874 \uB9C1\uD06C \uB370\uC774\uD130\uB97C \uAC80\uC0C9 \uC790\uC0B0\uC73C\uB85C \uC804\uD658")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M400 292 V330",
    stroke: "#c9d5de",
    strokeWidth: 6,
    strokeLinecap: "round",
    markerEnd: "url(#arrow)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M400 493 V531",
    stroke: "#b5dcea",
    strokeWidth: 6,
    strokeLinecap: "round",
    markerEnd: "url(#arrow)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M400 694 V732",
    stroke: "#8bcbed",
    strokeWidth: 6,
    strokeLinecap: "round",
    markerEnd: "url(#arrow)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 146,
    width: 696,
    height: 146,
    rx: 28,
    fill: "#f4f7f9",
    stroke: "#dce4ea",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 180,
    width: 126,
    height: 78,
    rx: 18,
    fill: "#ffffff",
    stroke: "#cbd7df",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116 207 H194 M116 232 H180",
    stroke: "#91a4b2",
    strokeWidth: 7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202,
    cy: 232,
    r: 8,
    fill: "#69bce6"
  }), /*#__PURE__*/React.createElement("text", {
    x: 270,
    y: 211,
    className: "label"
  }, "36\uB9CC+ \uB9C1\uD06C"), /*#__PURE__*/React.createElement("text", {
    x: 270,
    y: 251,
    className: "caption"
  }, "6\uAC1C \uC81C\uD734\uCC98"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 347,
    width: 696,
    height: 146,
    rx: 28,
    fill: "#f1f8fb",
    stroke: "#cfe8f5",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 382 H218 L179 420 V454 L143 470 V420Z",
    fill: "#ffffff",
    stroke: "#69bce6",
    strokeWidth: 5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 270,
    y: 412,
    className: "label"
  }, "URL \uC815\uC81C"), /*#__PURE__*/React.createElement("text", {
    x: 270,
    y: 452,
    className: "caption"
  }, "\uD544\uD130 \xB7 \uC911\uBCF5 \uC81C\uAC70"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 548,
    width: 696,
    height: 146,
    rx: 28,
    fill: "#eef8fd",
    stroke: "#b9def1",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 614,
    r: 42,
    fill: "#ffffff",
    stroke: "#43a9df",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179 643 L213 677",
    stroke: "#43a9df",
    strokeWidth: 9,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 270,
    y: 613,
    className: "label-accent"
  }, "\uD1B5\uD569 \uAC80\uC0C9"), /*#__PURE__*/React.createElement("text", {
    x: 270,
    y: 653,
    className: "caption"
  }, "\uAC80\uC0C9 \xB7 \uD53C\uB4DC\uBC31"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 749,
    width: 696,
    height: 146,
    rx: 28,
    fill: "#e8f6fd",
    stroke: "#8ccfee",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 155,
    cy: 822,
    r: 54,
    fill: "#ffffff",
    stroke: "#56b2df",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 822 L148 842 L184 800",
    fill: "none",
    stroke: "#1377ad",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 270,
    y: 814,
    className: "label-accent"
  }, "\uB9C1\uD06C \uC0DD\uC131"), /*#__PURE__*/React.createElement("text", {
    x: 270,
    y: 854,
    className: "caption"
  }, "71% \uC0DD\uC131 \uC804\uD658"))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 926,
    width: 616,
    height: 54,
    rx: 27,
    fill: "#eaf6fc"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 961,
    textAnchor: "middle",
    className: "caption",
    fill: "#3689b5"
  }, "\uD0A4\uC6CC\uB4DC + \uC758\uBBF8 \uAE30\uBC18 \uAC80\uC0C9 \xB7 RRF \uB7AD\uD0B9 \uC124\uACC4")), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 1010,
    width: 216,
    height: 104,
    rx: 22,
    fill: "#ffffff",
    stroke: "#dce4ea",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 160,
    y: 1052,
    textAnchor: "middle",
    className: "metric"
  }, "4,900\uBA85"), /*#__PURE__*/React.createElement("text", {
    x: 160,
    y: 1084,
    textAnchor: "middle",
    className: "metric-label"
  }, "\uAC80\uC0C9 \uD06C\uB9AC\uC5D0\uC774\uD130"), /*#__PURE__*/React.createElement("rect", {
    x: 292,
    y: 1010,
    width: 216,
    height: 104,
    rx: 22,
    fill: "#ffffff",
    stroke: "#cfe8f5",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 1052,
    textAnchor: "middle",
    className: "metric"
  }, "3.3\uB9CC \uAC80\uC0C9"), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 1084,
    textAnchor: "middle",
    className: "metric-label"
  }, "\uC624\uD508 3\uC8FC \uB204\uC801"), /*#__PURE__*/React.createElement("rect", {
    x: 532,
    y: 1010,
    width: 216,
    height: 104,
    rx: 22,
    fill: "#ffffff",
    stroke: "#b9def1",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 640,
    y: 1052,
    textAnchor: "middle",
    className: "metric"
  }, "40%+"), /*#__PURE__*/React.createElement("text", {
    x: 640,
    y: 1084,
    textAnchor: "middle",
    className: "metric-label"
  }, "\uC2E0\uADDC 7\uC77C \uB0B4 \uC0DD\uC131"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegratedSearchArchitectureMobile);
export default __webpack_public_path__ + "static/media/integrated-search-architecture-mobile.0b6717ae722176368c05dadf69a5529e.svg";
export { ForwardRef as ReactComponent };